import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import initScrollTrigger from '../helpers/initScrollTrigger';
// import {debounce} from 'throttle-debounce';

import сustomPageScroll from './custom-scroll';

import isPortrait from '../helpers/isPortrait';
gsap.registerPlugin(ScrollTrigger);

export default () => {
	initScrollTrigger();
	const fadeBlocks = document.querySelectorAll('.js-fade');

	fadeBlocks.forEach((block) => {
		gsap.from(block, {
			opacity: 0,
			duration: 1,
		
			scrollTrigger: {
				trigger: block,
				markers: false,
				start:  () => {
					return isPortrait() ? 'top 90%' : 'top 85%';
				},
				end: 'bottom top',
			},
		});
	});
}
